<template>
  <div id="big-boxes-perception" class="big-box">
    <div class="mainline">
      <span class="primary">
        <ez-modal-dice
          slot="underline"
          name="Perception"
          :dice="`1d20+${perceptionBonus}`">
          {{ perceptionBonus || 0 }}
        </ez-modal-dice>
      </span>
    </div>

    <label @click="toggleState = !toggleState" class="has-toggle">
      <span class="d-none d-lg-inline">Perception</span>
      <span class="d-inline d-lg-none">Per</span>
    </label>
    <toggle :id="'perception-' + this._uid" v-model="toggleState"></toggle>

    <div v-if="toggleState" class="text-center">
      <proficiency v-model="perception.proficiency">Proficiency</proficiency>
      <under-input v-model.number="perception.misc" type="number" maxlength="2">Misc</under-input>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import Proficiency from "../shared/_Proficiency.vue";
import Toggle from "../shared/_Toggle.vue";
import UnderInput from "../shared/_UnderInput.vue";

export default {
  name: "big-boxes-perception",
  components: {
    EzModalDice,
    Proficiency,
    Toggle,
    UnderInput
  },
  data() {
    return {
      toggleState: false
    };
  },
  computed: {
    ...mapState({
      ruleset: state => state.characters.current.ruleset,
      experience: state => state.characters.current.core.experience,
      perception: state => state.characters.current.offense.perception,
      attributes: state => state.characters.current.attributes
    }),
    attribute() {
      return this.attributes.find(x => x.name === this.perception.attribute);
    },
    perceptionBonus() {
      let bonus = this.$rulesets[this.ruleset].getProficiencyBonus(
        this.experience,
        this.perception,
        this.attribute
      );
      return bonus;
    }
  }
};
</script>
